// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Medal40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Medal40Filled: FC<Medal40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M20 21.389c-1.296 0-2.407-.463-3.333-1.389-.926-.926-1.39-2.037-1.39-3.333 0-1.297.464-2.408 1.39-3.334.925-.925 2.037-1.388 3.333-1.388 1.296 0 2.407.463 3.333 1.389.926.925 1.39 2.036 1.39 3.333 0 1.296-.464 2.407-1.39 3.333-.925.926-2.037 1.389-3.333 1.389Zm-9.889 16.945V25.596C8.926 24.338 8.056 22.94 7.5 21.403a13.833 13.833 0 0 1-.833-4.736c0-3.76 1.282-6.921 3.847-9.486C13.079 4.616 16.24 3.333 20 3.333c3.76 0 6.921 1.283 9.486 3.848 2.565 2.565 3.847 5.727 3.847 9.486 0 1.62-.277 3.199-.833 4.736-.555 1.537-1.426 2.935-2.611 4.194v12.736L20 35.029l-9.889 3.306ZM20 27.221c2.945 0 5.44-1.023 7.486-3.069 2.046-2.046 3.07-4.542 3.07-7.486 0-2.945-1.024-5.44-3.07-7.486C25.44 7.134 22.945 6.11 20 6.11c-2.944 0-5.44 1.023-7.486 3.07-2.046 2.046-3.07 4.541-3.07 7.486 0 2.944 1.024 5.44 3.07 7.486 2.046 2.046 4.542 3.07 7.486 3.07Z" />
        </svg>
    );
};

export default Medal40Filled;
